import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  selectedProduct,
  removeSelectedProduct,
} from "../redux/actions/productsActions";
const ProductDetails = () => {
  const { productId } = useParams();
  let product = useSelector((state) => state.product);
  const { image, title, price, category, description,durl } = product;
  const dispatch = useDispatch();
  
  
  const fetchProductDetail = async (id) => {
    const response = await axios
      //.get(`http://45.63.0.98:5000/product/${productId}`)
      //.get(`https://zf6867vlrd.execute-api.us-east-1.amazonaws.com/prod/product?id=${productId}`)
      //.get(`https://zf6867vlrd.execute-api.us-east-1.amazonaws.com/prod/product?id=2`)
      .get(`https://zf6867vlrd.execute-api.us-east-1.amazonaws.com/prod/product?id=${productId}`)
      .catch((error) => {
        console.log("Err: ", error);
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
      });
    console.log(response.data)
    //const dt = response.data.filter(item => item.id === id)
      dispatch(selectedProduct(response.data));
  };

  useEffect(() => {
    if (productId && productId !== "") fetchProductDetail(productId);
    return () => {
      dispatch(removeSelectedProduct());
    };
  }, [productId]);
  return (
    <div className="ui grid container">
      {Object.keys(product).length === 0 ? (
        <div>...Loading</div>
      ) : (
        <div className="ui placeholder segment">
          <div className="ui two column stackable center aligned grid">
            <div className="ui vertical divider">AND</div>
            <div className="middle aligned row">
              <div className="column lp">
                <img className="ui fluid image" src={image} />
              </div>
              <div className="column rp">
                <h1>{title}</h1>
                <h2>
                  <a className="ui teal tag label">${price}</a>
                </h2>
                <h3 className="ui brown block header">{category}</h3>
                <p>{description}</p>
                
                <div className="ui vertical animated button" tabIndex="0">
                <a target="_blank" href={durl}>
                  <div className="hidden content">
                  {/* <a target="_blank" href="https://amazon.ca">Policies</a> */}
                    <i className="shop icon"></i>
                    
                  </div>
                  </a>
                  <div className="visible content">Get Deal</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      )}
    </div>
  );
};

export default ProductDetails;
